<template>
  <div class="b-content">
    <swiper ref="mySwiper" :options="swiperOptions">
      <swiper-slide v-for="(item,index) in colorTarArr" :key="item.code"
                    :class="{'swiper-slide-active-item':item.code === selectColorCode}">
        <div class="slide-content swiper-no-swiping" @click="switchColor(index, item.code)">
          <div class="color">
            <div class="color-inner" v-if="colorImageTar[item.code]" :style="{backgroundImage:`url(${colorImageTar[item.code]})`}">
            </div>
            <div class="color-inner" v-else :style="{background:`${item.color}`}">
              <template v-if="Array.isArray(item.color)">
                <span class="img-child" v-for="c in item.color" :key="c" :style="{background:`${c}`}"></span>
              </template>
            </div>
          </div>
          <div class="name">{{ item.title }}</div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
    <div class="number360d"></div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import requireJson from "@/utils/requireJson";

export default {
  name: "outer",
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    },
    ...mapGetters(['selectTypeItem']),
    ...mapState({
      selectColorCode: state => state.selectColorCode,
      carId: state => state.carConfig.id,
      selectTypeId: state => state.selectTypeId,
      colorArr: state => state.colorArr,
      colorConfig: state => state.colorConfig,
      carConfig: state => state.carConfig,
    }),
    colorTarArr: vm => vm.colorArr.map(code => {
      const base = Object.values(vm.colorConfig).find(o => o.code === code) || {}
      let carCustom={}
      if(vm.carConfig['colorMap']){
        carCustom = vm.carConfig['colorMap'][code]||{};
        if(vm.carConfig['colorMap'][vm.selectTypeId]){
          carCustom = vm.carConfig['colorMap'][vm.selectTypeId][code]||carCustom;
        }
      }
      return {
        ...base,
        ...carCustom,
      }
    })
  },
  mounted() {
    const index = this.colorArr.findIndex(o => o === this.selectColorCode)
    console.log(index)
    this.swiper.slideTo(index);

    this.colorImageTar = this.colorArr.reduce((prev,item)=>{
      prev[item] = this.requireImg(item)
      return prev
    },{})
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: '8',//显示个数
        direction: 'horizontal',
        centerInsufficientSlides: true,
        breakpoints: {
          768: {  //当屏幕宽度大于等于768
            slidesPerView: 4,
          }
        },
        normalizeSlideIndex: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        noSwiping: true
      },
      colorImageTar:{}
    }
  },
  methods: {
    ...mapActions(['setSelectColorCode']),
    switchColor(index, code) {
      console.log(index, code)
      this.swiper.slideTo(index);
      this.setSelectColorCode(code)
    },
    requireImg(color) {
      let path = ''
      try {
        path = require(`assets/color/${color}.png`)
      } catch (e) {
        console.log(e)
      }

      return path
    }
  }
}
</script>

<style scoped>

</style>
